<div id="modal-decision">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" aria-label="Close" data-dismiss="modal-decision" (click)="cerrar('')"></button>
    </div>
    <div class="modal-body text-center">
        <div class="icons">
            <div class="swal2-icon swal2-error swal2-animate-error-icon">
                <span class="swal2-x-mark swal2-animate-x-mark">
                    <span class="swal2-x-mark-line-left"></span>
                    <span class="swal2-x-mark-line-right"></span>
                </span>
            </div>
        </div>
        <h3 [innerHTML]="mensaje"></h3>
    </div>

    <div class="modal-footer border-0">
        <button id="neoBtnAccept" type="button" class="btn btn-primary" (click)="cerrar('aceptar')">Aceptar</button>
    </div>
</div>
